// Registration's own pages: open, capture, setup, legal, emails, theme, publish.
//
// IN THE ADDRESS, NOT ONLY IN REACT STATE. Same argument as KioskNav: a selected
// tab that lives only in memory is a tab a reload throws away.
//
// Nested under Registration in the rail, the way a section's faces sit under
// its heading. Not a second strip across the page.

import type { ReactNode } from "react";
import type { RegistrationPanel } from "../routes/route.js";

export type RegistrationNavProps = {
  readonly panel: RegistrationPanel;
  readonly onOpen: (panel: RegistrationPanel) => void;
  readonly className?: string;
  /** Whether Theme is offered to this reader (roleAccess.ts). Omitted, it is. */
  readonly offerTheme?: boolean;
  /** Whether Emails is offered to this reader (roleAccess.ts, `registrationEmails`). Omitted, it is. */
  readonly offerEmails?: boolean;
};

export const REGISTRATION_NAV_ITEMS: readonly {
  readonly panel: RegistrationPanel;
  readonly label: string;
}[] = [
  { panel: "open", label: "Open" },
  { panel: "capture", label: "Who can register" },
  { panel: "setup", label: "Registration setup" },
  { panel: "legal", label: "Legal copy" },
  { panel: "emails", label: "Emails" },
  { panel: "theme", label: "Theme" },
  { panel: "publish", label: "Publish Live" },
];

export function RegistrationNav({ panel, onOpen, className, offerTheme = true, offerEmails = true }: RegistrationNavProps): ReactNode {
  const items = REGISTRATION_NAV_ITEMS.filter(
    (item) => (offerTheme || item.panel !== "theme") && (offerEmails || item.panel !== "emails"),
  );
  return (
    <nav className={className === undefined ? "sub" : className} aria-label="Registration pages">
      {items.map((item) => (
        <button
          key={item.panel}
          type="button"
          aria-current={item.panel === panel ? "page" : undefined}
          onClick={() => onOpen(item.panel)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}
